// src/features/cart/services/cartService.ts

import { api } from '../../../services/api/axios';
import { authService } from '../../auth/services/authService';
import { CartResponse } from '../types';

export interface AddToCartPayload {
  id: number;
  variation_id?: number;
  quantity: number;
  attributes?: Record<string, string>;
}

export const cartService = {
  getCart: async (): Promise<CartResponse> => {
    const token = authService.getToken();
    try {
      const response = await api.get('cart', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  addToCart: async (payload: AddToCartPayload): Promise<void> => {
    const token = authService.getToken();
    try {
      await api.post('cart/add', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  updateCart: async (payload: { cart_key: string; quantity: number }): Promise<void> => {
    const token = authService.getToken();
    try {
      await api.post('cart/update', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  removeFromCart: async (cart_key: string): Promise<void> => {
    const token = authService.getToken();
    try {
      await api.post('cart/remove', { cart_key }, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },
};
